import { useParams, useEffect } from 'react';
import { Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/feature/ScrollToTop';
import Breadcrumb from '@/components/feature/Breadcrumb';
import ArticleContent from './components/ArticleContent';
import RelatedArticles from './components/RelatedArticles';
import { articles } from '@/mocks/articles';

export default function ArticlePage() {
  const { slug } = useParams<{ slug: string }>();

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, [slug]);

  const article = articles.find((a) => a.slug === slug);

  if (!article) {
    return (
      <>
        <Navbar />
        <main className="pt-16 min-h-screen flex items-center justify-center">
          <div className="text-center px-4">
            <div className="w-20 h-20 mx-auto mb-4 rounded-full bg-background-100 flex items-center justify-center">
              <i className="ri-file-unknow-line text-3xl text-foreground-400"></i>
            </div>
            <h1 className="font-heading text-xl font-bold text-foreground-950 mb-2">文章未找到</h1>
            <p className="text-sm text-foreground-600 mb-6">该文章可能已被移除或不存在</p>
            <Link
              to="/"
              className="inline-flex items-center gap-2 px-5 py-2.5 rounded-lg bg-primary-500 text-background-50 text-sm font-medium hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
            >
              <i className="ri-home-line"></i>
              返回首页
            </Link>
          </div>
        </main>
        <Footer />
      </>
    );
  }

  return (
    <>
      <Navbar />
      <main className="pt-16 pb-14">
        <div className="max-w-7xl mx-auto px-4 md:px-6 pt-6">
          <Breadcrumb
            items={[
              { name: '首页', path: '/' },
              { name: article.categoryName, path: `/category/${article.category}` },
              { name: article.title },
            ]}
          />
          <div className="py-6 md:py-10">
            <ArticleContent
              title={article.title}
              slug={article.slug}
              category={article.category}
              categoryName={article.categoryName}
              date={article.date}
              readTime={article.readTime}
              content={article.content}
            />
            <RelatedArticles
              currentSlug={article.slug}
              category={article.category}
              articles={articles}
            />
          </div>
        </div>
      </main>
      <Footer />
      <ScrollToTop />
    </>
  );
}